export default "__VITE_ASSET__jXv5vWel__"